<template>
  <div class="course">
    <TabPageLayout activeCode="yizhongkecheng" :activeId="activeTabId" v-if="activeTabId">
      <div class="container internationalCourse">
        <div class="div_mod">
          <div class="div_tit" v-for="(block, index) in blocks" :key="block.id">
            <h2>{{ block.title }}</h2>
            <div v-html="block.bz"></div>

            <div>
              <div class="div_mod1" v-if="block.code === 'BusinessCard'">
                <ul class="ul_nulist numCount">
                  <li v-for="subItem in blockChildren[index]" :key="subItem.id">
                    <div class="num" v-html="subItem.bz"></div>
                    <p>{{ subItem.title }}</p>
                  </li>
                </ul>
              </div>

              <div
                class="div_mod3"
                v-else-if="block.code === 'CurriculumSystem'"
              >
                <ul>
                  <li v-for="subItem in blockChildren[index]" :key="subItem.id">
                    <div class="div1">
                      <img :src="subItem.bgimg" alt="" />
                      <p>{{ subItem.title }}</p>
                    </div>
                    <div class="div2">
                      <h4>{{ subItem.title.split(" ")[0] }}</h4>
                      <span>{{ subItem.title }}</span>
                      <div v-html="subItem.bz"></div>
                      <a @click="toDetail(subItem.articleId)"> 了解更多 </a>
                    </div>
                  </li>
                </ul>
              </div>
              <div
                class="div_mod4"
                v-else-if="block.code === 'DiversifiedExploration'"
              >
                <ul>
                  <li
                    style="padding-left: 0"
                    v-for="subItem in blockChildren[index]"
                    :key="subItem.id"
                  >
                    <img :src="subItem.bgimg" alt="" />
                    <div class="div_info">
                      <img :src="subItem.imgbz" alt="" />
                      <h3>{{ subItem.title }}</h3>
                      <div class="bz">
                        <div v-html="subItem.bz"></div>
                      </div>
                      <a @click="toBlockDetailPage(subItem.id)"> 了解更多 </a>
                    </div>
                  </li>
                </ul>
              </div>
              <div class="lunbo lunbo1" v-else-if="block.code === 'timeAxis'">
                <!-- 所有有关文章展示 -->
                <div class="swiper-container">
                  <div class="swiper-wrapper">
                    <div
                      class="swiper-slide"
                      v-for="aside in timeAxis"
                      :key="aside.id"
                    >
                      <div>
                        <img :src="aside.bgimg" alt="" />
                        <p>{{ aside.title }}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="direction">
                  <span class="s_prev"><i></i></span>
                  <span class="s_next"><i></i></span>
                </div>
              </div>
              <div v-else-if="block.code === 'internationalExchange'">
                <div class="lunbo article-lunbo one">
                  <div class="swiper-container">
                    <ul class="swiper-wrapper">
                      <li
                        class="swiper-slide"
                        v-for="article in blockArticles[index]"
                        :key="article.id"
                      >
                        <ArticleCard
                          :article="article"
                          activeCode="yizhongkecheng"
                        />
                      </li>
                    </ul>
                  </div>
                  <div class="direction">
                    <span class="s_prev"><i></i></span>
                    <span class="s_next"><i></i></span>
                  </div>
                </div>
              </div>
              <div v-else-if="block.code === 'flashBoy'">
                <div class="lunbo article-lunbo two">
                  <div class="swiper-container">
                    <ul class="swiper-wrapper">
                      <li
                        class="swiper-slide"
                        v-for="article in blockArticles[index]"
                        :key="article.id"
                      >
                        <ArticleCard
                          :article="article"
                          activeCode="yizhongkecheng"
                        />
                      </li>
                    </ul>
                  </div>
                  <div class="direction">
                    <span class="s_prev"><i></i></span>
                    <span class="s_next"><i></i></span>
                  </div>
                </div>
                <!-- <div class="div_codeimg" :style="{
                  background: `url(${block.bgimg}) no-repeat center`
                }">
                  <div class="div_code">
                    <img :src="block.imgbz" alt="">
                  </div>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </TabPageLayout>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import TabPageLayout from './components/TabPageLayout.vue'
import { useGetCategories } from './utils/useGetCategories'
import portalApi from '../../../lvya-common/src/api/eos/portal'
import ArticleCard from './components/ArticleCard.vue'

export default {
  components: {
    TabPageLayout,
    ArticleCard,
  },
  computed: {
    ...mapState({
      nav: (state) => state.yzsyStore.nav,
    }),
    typeId() {
      return (
        this.nav?.find((item) => item.code === 'yizhongkecheng')?.stypes[1]
          ?.id || undefined
      )
    },
    schoolYear() {},
    activeTabId() {
      return this.typeId
    },
  },
  data() {
    return {
      blocks: [],
      blockArticles: [],
      blockChildren: [],
      timeAxis: [],
    }
  },
  methods: {
    toBlockDetailPage(typeId) {
      this.$router.push({
        path: '/portalYZSYCurriculumSystem',
        query: {
          typeId,
        },
      })
    },
    toDetail(articleId) {
      // console.log(articleId, '1111')
      this.$router.push({ path: '/portalDetails', query: { id: articleId, activeCode: 'yizhongkecheng', code: 'guojikecheng', columnId: this.typeId }})
    },
    async getBlocks() {
      const categories = await useGetCategories(this.typeId)
      console.log({ categories })
      this.blocks = categories.list
      // console.log(this.blocks, 'this.blocks')
      // for (let index = 0; index < categories?.list?.length; index++) {
      //   const nav = categories?.list[index]
      //   console.log(nav, '22222')
      // }
      const resData = await portalApi.getTypeListByPage({ pId: categories?.list[2]?.id, pageNum: '1', pageSize: '99999', })
      console.log(resData, 'resData')
      this.timeAxis = resData.list
    },
    async getBlockChildren() {
      for (const block of this.blocks) {
        const children = await useGetCategories(block.id)
        // 获取栏目下的第一篇文章
        if (block.code === 'CurriculumSystem') {
          for (let index = 0; index < children.list?.length; index++) {
              let reqData = {
                noSchoolId: true,
                schoolId: '7',
                pageNum: 1,
                pageSize: 999,
                typeId: children.list[index].id,
              }
            let resDataWz = await portalApi.getArtsByPage(reqData)
            children.list[index].articleId = resDataWz?.list[0]?.id
          }
        }
        this.blockChildren.push(children.list)
      }
    },
    async getArticles() {
      // const portalSchoolInfo = JSON.parse(
      //   localStorage.getItem('portalSchoolInfo')
      // )
      const articles = []
      for (const block of this.blocks) {
        // console.log(block, 'block')
        let reqData = {
          noSchoolId: true,
          schoolId: '7',
          pageNum: 1,
          pageSize: 999,
          typeId: block.id,
          isContent: 'Y',
          applyState: 'Y',
        }
        let resData = await portalApi.getArtsByPage(reqData)
        // console.log(resData, 'articles')
        articles.push(resData?.list)
        // console.log(articles, 'articles')
      }
      this.blockArticles = articles
    },
  },
  async mounted() {
    await this.getBlocks()
    await this.getBlockChildren()
    await this.getArticles()

    $('.internationalCourse .div_mod3 ul li').hover(
      function() {
        var obj = $(this)
        $(obj).find('.div2').stop().animate({ opacity: 1 }, 300)
      },
      function() {
        var obj = $(this)
        $(obj).find('.div2').stop().animate({ opacity: 0 }, 300)
      }
    )

    $('.internationalCourse .div_mod4 ul li').hover(
      function() {
        var obj = $(this)

        $(obj)
          .find('.div_info')
          .stop()
          .animate({ 'padding-top': '.6rem', opacity: 1 }, 300)

        $(obj).addClass('lihover')
      },
      function() {
        var obj = $(this)

        $(obj)
          .find('.div_info')
          .stop()
          .animate({ 'padding-top': '1.2rem', opacity: 1 }, 300)

        $(obj).removeClass('lihover')
      }
    )
    new Swiper('.one .swiper-container', {
      loop: false,
      slidesPerView: 1, // 一行显示3个
      spaceBetween: 30,
      navigation: {
        nextEl: '.one .s_next',
        prevEl: '.one .s_prev',
      },

      breakpoints: {
        1024: {
          // 当屏幕宽度大于等于320
          slidesPerView: 3,
          spaceBetween: 30,
        },
      },
    })
    new Swiper('.two .swiper-container', {
      loop: false,
      slidesPerView: 1, // 一行显示3个
      spaceBetween: 30,
      navigation: {
        nextEl: '.two .s_next',
        prevEl: '.two .s_prev',
      },

      breakpoints: {
        1024: {
          // 当屏幕宽度大于等于320
          slidesPerView: 3,
          spaceBetween: 30,
        },
      },
    })
    this.swiper = new Swiper('.internationalCourse .lunbo1 .swiper-container', {
        watchSlidesVisibility: true,
        slidesPerView: 1,
        spaceBetween: 30,
        loop: false,
        navigation: {
          nextEl: '.lunbo1 .s_next',
          prevEl: '.lunbo1 .s_prev',
        },
        breakpoints: {
          1023: {
            // 当屏幕宽度大于等于102333
            slidesPerView: 3,
            spaceBetween: 30,
          },
        },
      })
  },
}
</script>

<style lang="less" scoped>
// @import "./style/common.css";
@import "./style/course.css";
@import "./style/global.css";
.container .div_tit .div2 span {
  color: #fff;
  text-align: center;
  display: block;
  width: 100%;
}
.div_info {
  .bz *{
    text-align: center !important;
    color: #fff !important;
    margin-bottom: 0.1rem;
  }
}

// .article-lunbo {
//   position: relative;
// }
.lunbo.article-lunbo {
  background: transparent;
}
.article-lunbo ul {
  /deep/ li {
    background: #fff;
    box-shadow: 0px 1px 9.8px 0.2px rgba(0, 0, 0, 0.1);
    &:hover {
      .imgbox img {
        transform: scale(1.1);
      }
    }
    .imgbox {
      overflow: hidden;
      img {
        transform: scale(1);
        transition: transform 0.3s linear;
      }
    }
    .txtbox {
      padding: 0.3rem;
      overflow: hidden;
      text-align: center;
      b {
        display: none;
      }
      h3 {
        height: 70px;
        text-align: left;
        font-size: 0.24rem;
        color: #333;
        line-height: 1.5;
        margin-bottom: 0.15rem;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      p {
        font-size: 0.16rem;
        color: #555;
        opacity: 0.8;
        line-height: 1.5;
        margin-bottom: 0.15rem;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      span {
        display: block;
        width: 1.3rem;
        height: 0.48rem;
        line-height: 0.46rem;
        text-align: center;
        border: 1px solid #f5a100;
        font-size: 0.16rem;
        color: #f5a100;
        border-radius: 10px;
        float: right;
        // position: absolute;
        right: 0.3rem;
        bottom: 0.3rem;
        cursor: pointer;
      }
    }
  }
}

@media screen and (max-width: 1023px) {
  .direction span {
    top: 50%;
  }
}
/deep/.num {
  p {
    font-size: 0.6rem !important;
    color: #f5a100 !important;
    margin-bottom: 0.1rem !important;
  }
}
</style>
